import { ClienteDetalheResponse } from "../typings";
import axios from "infra/http";
import { useQuery } from "react-query";

function useCliente(id?: string) {
  return useQuery(
    `/v1/cliente/${id}`,
    async () => {
      const res = await axios.get<ClienteDetalheResponse>(`/v1/cliente/${id}`);

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useCliente;
